/* ==========================================================================
   KCONV Accessoires – add-to-cart logica voor accessoire-kaartjes.
   Werkt op ALLE grids met [data-kconv-acc-grid] (teaser + strip tegelijk).
   Gebaseerd op de bestaande accessoires-logica uit kc-collapsible-content,
   maar losgemaakt zodat het buiten die sectie werkt. Raakt geen kernbestand aan.
   ========================================================================== */
(function () {
  if (window.__kconvAccInit) return;
  window.__kconvAccInit = true;

  var cartCache = null;
  var cartCacheTime = 0;
  var CACHE_TTL = 2000;

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (r) {
      return r.ok ? r.json() : Promise.reject(r);
    });
  }

  function getCart(forceRefresh) {
    var now = Date.now();
    if (!forceRefresh && cartCache && now - cartCacheTime < CACHE_TTL) {
      return Promise.resolve(cartCache);
    }
    return fetchJSON('/cart.js').then(function (cart) {
      cartCache = cart;
      cartCacheTime = Date.now();
      return cart;
    });
  }

  function updateCartBadges() {
    var sectionsToRender = [
      { id: 'Top-Cart-Bubble', section: 'cart-icon-bubble' },
      { id: 'Bottom-Cart-Bubble', section: 'cart-icon-bubble' }
    ];
    var sectionParams = sectionsToRender
      .map(function (s) { return s.section; })
      .join(',');
    fetch((window.Shopify ? window.Shopify.routes.root : '/') + '?sections=' + sectionParams)
      .then(function (response) { return response.json(); })
      .then(function (sections) {
        sectionsToRender.forEach(function (s) {
          var el = document.getElementById(s.id);
          if (el && sections[s.section]) {
            el.innerHTML = new DOMParser()
              .parseFromString(sections[s.section], 'text/html')
              .querySelector('.shopify-section').innerHTML;
          }
        });
      })
      .catch(function () {
        getCart(true).then(function (c) {
          var n = c && typeof c.item_count === 'number' ? c.item_count : 0;
          document
            .querySelectorAll('[data-cart-count], .cart-count-bubble .text, .cart-count-bubble .count')
            .forEach(function (el) {
              el.textContent = n;
              el.classList && el.classList.remove('hidden');
            });
        });
      });
  }

  function getQuantityInCart(cart, variantId) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    var total = 0;
    cart.items.forEach(function (item) {
      if (String(item.variant_id) === String(variantId)) total += item.quantity;
    });
    return total;
  }

  function activeCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  }

  // Formatteer bedragen in de ACTIEVE (presentment) valuta, net als de rest
  // van het thema. Bedragen staan al in de juiste valuta (subeenheden).
  function formatMoney(cents) {
    try {
      if (typeof webvista !== 'undefined' && webvista && typeof webvista.formatPriceAmount === 'function') {
        var out = webvista.formatPriceAmount(cents, activeCurrency());
        if (out) return out;
      }
    } catch (e) {}
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: activeCurrency() }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function allCards() {
    return document.querySelectorAll('[data-kconv-acc-grid] [data-accessoire-card]');
  }

  function updateCardState(card, cart) {
    var variantId = card.dataset.variantId;
    var allowBackorder = card.dataset.allowBackorder === 'true';
    var inventory = parseInt(card.dataset.inventory, 10) || 0;

    var qtyInput = card.querySelector('[data-accessoire-quantity-input]');
    var addBtn = card.querySelector('[data-accessoire-add-button]');
    var minusBtn = card.querySelector('[data-qty-minus]');
    var plusBtn = card.querySelector('[data-qty-plus]');
    var statusEl = card.querySelector('[data-accessoire-cart-status]');

    var variantSelect = card.querySelector('[data-accessoire-variant-select]');
    if (variantSelect) {
      var selectedOption = variantSelect.options[variantSelect.selectedIndex];
      if (selectedOption) {
        inventory = parseInt(selectedOption.dataset.inventory, 10) || 0;
        allowBackorder = selectedOption.dataset.allowBackorder === 'true';
      }
    }

    var inCart = getQuantityInCart(cart, variantId);
    var availableToAdd = allowBackorder ? 9999 : Math.max(0, inventory - inCart);
    var currentQty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;

    if (qtyInput) {
      if (allowBackorder) {
        qtyInput.removeAttribute('max');
      } else {
        qtyInput.setAttribute('max', availableToAdd);
        if (currentQty > availableToAdd) {
          qtyInput.value = Math.max(1, availableToAdd);
          currentQty = Math.max(1, availableToAdd);
        }
      }
      if (minusBtn) minusBtn.disabled = currentQty <= 1;
      if (plusBtn) plusBtn.disabled = !allowBackorder && currentQty >= availableToAdd;
    }

    if (addBtn) {
      var isMaxed = !allowBackorder && availableToAdd <= 0;
      var unavailable = card.classList.contains('acc-card--unavailable');
      addBtn.disabled = isMaxed || unavailable;
      addBtn.classList.toggle('acc-card__add-btn--maxed', isMaxed);
      var btnText = addBtn.querySelector('.acc-card__add-text');
      if (btnText) btnText.textContent = isMaxed ? 'Max bereikt' : 'Toevoegen';
    }

    if (statusEl) {
      if (inCart > 0) {
        var variantTitle = '';
        if (variantSelect) {
          var opt = variantSelect.options[variantSelect.selectedIndex];
          if (opt && opt.text && opt.text !== 'Default Title') {
            variantTitle = opt.text.split(' - ')[0];
          }
        }
        statusEl.textContent =
          variantTitle && variantTitle !== 'Default Title'
            ? variantTitle + ' zit ' + inCart + 'x in je winkelwagen'
            : inCart + 'x in je winkelwagen';
        statusEl.hidden = false;
      } else {
        statusEl.hidden = true;
        statusEl.textContent = '';
      }
    }
  }

  function updateAllCards() {
    getCart(true).then(function (cart) {
      allCards().forEach(function (card) { updateCardState(card, cart); });
    });
  }

  function initCard(card) {
    if (card.__kconvAccBound) return;
    card.__kconvAccBound = true;

    var addButton = card.querySelector('[data-accessoire-add-button]');
    var variantSelect = card.querySelector('[data-accessoire-variant-select]');
    var quantityInput = card.querySelector('[data-accessoire-quantity-input]');
    var minusBtn = card.querySelector('[data-qty-minus]');
    var plusBtn = card.querySelector('[data-qty-plus]');

    if (minusBtn && quantityInput) {
      minusBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var currentVal = parseInt(quantityInput.value, 10) || 1;
        if (currentVal > 1) {
          quantityInput.value = currentVal - 1;
          getCart().then(function (cart) { updateCardState(card, cart); });
        }
      });
    }

    if (plusBtn && quantityInput) {
      plusBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var currentVal = parseInt(quantityInput.value, 10) || 1;
        var maxVal = quantityInput.getAttribute('max');
        if (!maxVal || currentVal < parseInt(maxVal, 10)) {
          quantityInput.value = currentVal + 1;
          getCart().then(function (cart) { updateCardState(card, cart); });
        }
      });
    }

    if (quantityInput) {
      quantityInput.addEventListener('change', function () {
        var val = parseInt(quantityInput.value, 10) || 1;
        var min = parseInt(quantityInput.min, 10) || 1;
        var max = quantityInput.getAttribute('max');
        if (val < min) val = min;
        if (max && val > parseInt(max, 10)) val = parseInt(max, 10);
        quantityInput.value = val;
        getCart().then(function (cart) { updateCardState(card, cart); });
      });
    }

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var selectedOption = variantSelect.options[variantSelect.selectedIndex];
        if (!selectedOption) return;
        var newVariantId = selectedOption.value;
        var newPrice = parseInt(selectedOption.dataset.price, 10);
        var newComparePrice = parseInt(selectedOption.dataset.comparePrice, 10) || 0;
        var isAvailable = selectedOption.dataset.available === 'true';
        var newInventory = parseInt(selectedOption.dataset.inventory, 10) || 0;
        var newAllowBackorder = selectedOption.dataset.allowBackorder === 'true';

        card.dataset.variantId = newVariantId;
        card.dataset.inventory = newInventory;
        card.dataset.allowBackorder = newAllowBackorder;
        card.classList.toggle('acc-card--unavailable', !isAvailable);

        var priceEl = card.querySelector('.acc-card__price');
        var priceCompareEl = card.querySelector('.acc-card__price-compare');
        if (priceEl) priceEl.textContent = formatMoney(newPrice);
        if (priceCompareEl) {
          if (newComparePrice > newPrice) {
            priceCompareEl.textContent = formatMoney(newComparePrice);
            priceCompareEl.style.display = '';
          } else {
            priceCompareEl.style.display = 'none';
          }
        }

        var stockEl = card.querySelector('.acc-card__stock');
        if (stockEl) {
          var deliveryHtml = selectedOption.dataset.deliveryHtml;
          if (deliveryHtml) {
            stockEl.innerHTML = deliveryHtml;
            stockEl.className = 'acc-card__stock';
          } else if (!isAvailable) {
            stockEl.className = 'acc-card__stock stock-unavailable';
            stockEl.textContent = 'Uitverkocht';
          } else if (newAllowBackorder) {
            stockEl.className = 'acc-card__stock stock-backorder';
            stockEl.textContent = 'Backorder';
          } else {
            stockEl.className = 'acc-card__stock stock-in-stock';
            stockEl.textContent = 'Op voorraad';
          }
        }

        if (quantityInput) quantityInput.value = 1;
        getCart(true).then(function (cart) { updateCardState(card, cart); });
      });
    }

    if (addButton) {
      addButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (addButton.disabled || addButton.classList.contains('is-loading')) return;

        var variantId = card.dataset.variantId;
        var quantity = parseInt(quantityInput ? quantityInput.value : 1, 10) || 1;
        if (quantity < 1) quantity = 1;
        if (!variantId) return;

        addButton.classList.add('is-loading');
        addButton.disabled = true;

        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', quantity);

        fetchJSON('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        })
          .then(function () {
            addButton.classList.remove('is-loading');
            addButton.classList.add('is-success');
            if (quantityInput) quantityInput.value = 1;
            updateCartBadges();
            updateAllCards();
            document.dispatchEvent(new CustomEvent('cart:updated'));
            setTimeout(function () { addButton.classList.remove('is-success'); }, 1500);
          })
          .catch(function (err) {
            addButton.classList.remove('is-loading', 'is-success');
            addButton.disabled = false;
            if (err && typeof err.json === 'function') {
              err.json()
                .then(function (data) { alert(data.description || 'Er is een fout opgetreden. Probeer het opnieuw.'); })
                .catch(function () { alert('Er is een fout opgetreden. Probeer het opnieuw.'); });
            } else {
              alert('Er is een fout opgetreden. Probeer het opnieuw.');
            }
          });
      });
    }
  }

  function initSlider(slider) {
    if (slider.__kconvAccSlider) return;
    slider.__kconvAccSlider = true;
    var track = slider.querySelector('[data-kconv-acc-track]');
    var prev = slider.querySelector('[data-kconv-acc-prev]');
    var next = slider.querySelector('[data-kconv-acc-next]');
    if (!track) return;

    function step() {
      var card = track.querySelector('.acc-card');
      return card ? card.getBoundingClientRect().width : track.clientWidth;
    }
    function updateArrows() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= maxScroll;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(updateArrows); }, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function initAll() {
    allCards().forEach(initCard);
    document.querySelectorAll('[data-kconv-acc-slider]').forEach(initSlider);
    updateAllCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('cart:updated', updateAllCards);
  window.addEventListener('cart:updated', updateAllCards);

  var cartDrawer = document.querySelector('cart-drawer, cart-notification');
  if (cartDrawer) {
    var observer = new MutationObserver(function () { setTimeout(updateAllCards, 100); });
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }
})();
